module.exports = __webpack_public_path__ + "img/table-check.b8194bdd.svg";